import React from 'react';
import {
  Edit, SimpleForm, TextInput, required,
} from 'react-admin';

const MetaEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="route" type="text" validate={required()} />
      <TextInput source="title" type="text" />
      <TextInput source="image" type="text" />
      <TextInput source="keywords" type="text" />
      <TextInput source="description" type="text" />
      <TextInput source="robots" type="text" />
    </SimpleForm>
  </Edit>
);

export default MetaEdit;
